// TagsList.jsx — proc-v3 (F2.3f): SESTA VISTA DEL MONOLITE in React,
// lista "Tag", flag-gated (shell_proc_v3_tags, default OFF).
//
// Replica 1:1 renderTags di proc-v0.js:8974-9019: stesso titolo/sottotitolo/
// bottone (dal dict I18N, VERBATIM in api.js), stesse colonne (Tag come badge
// colorato di tagBadge, Prefisso, Categoria specifica, Fonte, Fornitori che lo
// usano), stesso ordinamento di default (usageCount desc — parità
// byte-per-byte via rank v1, pre-sort stabile v1:8975 compreso), stesso click
// riga → panorama tag DEL MONOLITE (tag-detail), stesso "+ Nuovo tag"
// (prompt v1 → dedupe su DB.tags → confirmWrite.createTag ⇒ payload identici,
// toast dal dict).
//
// La vista v1 NON è selectable e non ha bulk: nemmeno qui.
// CONFINI (pattern f23c): dettaglio tag = V1 (delega in api.js);
// MAI 'nav:badge' da questo modulo.

import React from 'react';
import { DataTable } from '../ui/DataTable.jsx';
import {
  tTag, TAG_TEXTS, readTags, tagParts,
  tagNameFilterText, tagScopeFilterText,
  openTagDetail, addNewTag,
} from './api.js';

export function TagsList({ win, tick }) {
  // dati: letti dallo store del monolite a ogni refresh (tick dal wrapper) —
  // stessa composizione del v1 (api.readTags)
  const data = React.useMemo(() => readTags(win), [win, tick]);

  const t = (k) => tTag(win, k);

  const columns = [
    {
      key: 'name',
      label: t('col.tag'),
      sortable: true,
      sortValue: (r) => r._v1Rank.name, // rank v1 ⇒ ordine byte-per-byte anche al click
      filterText: tagNameFilterText,
      render: (r, ctx) => {
        const p = tagParts(r.name); // stessa mappa colori di tagBadge v1 (proc-v0.js:3160)
        return (
          <span className={p.color + ' text-[10px] px-1.5 py-0.5 rounded inline-block'}>
            <ctx.Mark text={p.body} tokens={ctx.tokens} />
            {p.scope ? (
              <span className="opacity-60 font-normal"> @ <ctx.Mark text={p.scope} tokens={ctx.tokens} /></span>
            ) : null}
          </span>
        );
      },
    },
    {
      key: '_prefix',
      label: t('col.prefix'),
      sortable: true,
      sortValue: (r) => r._v1Rank._prefix, // rank v1
    },
    {
      key: '_scope',
      label: t('col.pinned_category'),
      sortable: true,
      sortValue: (r) => r._v1Rank._scope, // rank v1
      filterText: tagScopeFilterText,
      render: (r, ctx) => (r._scope
        ? <code className="bg-slate-100 px-1 rounded text-xs"><ctx.Mark text={r._scope} tokens={ctx.tokens} /></code>
        : <span className="text-slate-400">—</span>),
    },
    {
      key: 'kind',
      label: t('col.source'),
      sortable: true,
      sortValue: (r) => r._v1Rank.kind, // rank v1
    },
    {
      key: 'usageCount',
      label: t('col.suppliers_using'),
      sortable: true,
      sortValue: (r) => r._v1Rank.usageCount, // rank v1 (type number)
    },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-3">
        <div>
          <h1 className="text-2xl font-bold">{t('tag.title')}</h1>
          <p className="text-sm text-slate-500 mt-0.5">{t('tag.subtitle')}</p>
        </div>
        <button
          id="btn-new-tag"
          type="button"
          className="bg-slate-900 hover:bg-slate-800 text-white px-3 py-1.5 rounded text-sm"
          onClick={() => addNewTag(win)}
        >{t('tag.new')}</button>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-3" id="tags-table-mount">
        <DataTable
          columns={columns}
          rows={data.rows}
          rowKey="id"
          sort={{ key: 'usageCount', dir: 'desc' }}
          filterable
          onRowClick={(row) => openTagDetail(win, row.name)}
          emptyMessage={TAG_TEXTS.emptyMessage}
        />
      </div>
    </div>
  );
}

// Factory (pattern createProcV3Orders): il register/install la aggancia al
// WRAP di window.renderTags. render() idempotente sul container; unmount()
// libera il container (il monolite resta vivo per le altre viste).
export function createProcV3Tags(win) {
  let root = null;
  let mountedEl = null;
  let tick = 0;

  function render() {
    const container = win.document.getElementById('tags-content');
    if (!container) throw new Error('#tags-content assente');
    if (!root || mountedEl !== container || !container.isConnected) {
      if (root) { try { root.unmount(); } catch (e) { /* già smontato */ } }
      container.replaceChildren(); // eventuali resti del v1 (catch-up)
      root = win.ReactDOM.createRoot(container);
      mountedEl = container;
    }
    tick += 1; // ogni chiamata del wrapper = refresh dati (rerenderAll, createTag, rientro)
    root.render(<TagsList win={win} tick={tick} />);
  }

  function unmount() {
    if (root) {
      try { root.unmount(); } catch (e) { /* già smontato */ }
      root = null;
    }
    mountedEl = null;
  }

  function isMounted() { return !!root; }

  return { render, unmount, isMounted };
}
